import { render, staticRenderFns } from "./i-nav.vue?vue&type=template&id=56a2a982&scoped=true"
import script from "./i-nav.vue?vue&type=script&lang=js"
export * from "./i-nav.vue?vue&type=script&lang=js"
import style0 from "./i-nav.vue?vue&type=style&index=0&id=56a2a982&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a2a982",
  null
  
)

export default component.exports